import useDimensions from './useDimensions';

const useIsDesktop = () => {
  const { width } = useDimensions();
  return width >= 1150;
};

export default useIsDesktop;
